export const matchesQuery = (p, q) => {
  const s = q.toLowerCase();
  return (p.product_name || p.name || "").toLowerCase().includes(s) ||
    (p.sku || "").toLowerCase().includes(s) ||
    (p.alt_skus || []).some(a => (a || "").toLowerCase().includes(s));
};

export const findBySku = (list, q) => {
  const s = q.trim().toLowerCase();
  if (!s) return null;
  return list.find(p => (p.sku || "").toLowerCase() === s || (p.alt_skus || []).some(a => (a || "").toLowerCase() === s)) || null;
};

export const buildImagePrompt = (nameA, nameB) => {
  const a = (nameA || "").trim();
  const b = (nameB || "").trim();
  if (!a) return b;
  if (!b) return a;
  return a.toLowerCase() === b.toLowerCase() ? a : `${a} ${b}`;
};
